<template>
  <v-menu
    v-model="userMenu"
    :close-on-content-click="false"
    offset-y
    content-class="user-menu-box"
    class="mt-1"
  >
    <v-btn
      icon
      fab
      small
      slot="activator"
      color="rgb(63, 147, 226)"
      class="xs-toolbar-btn ma-0 user-menu-activator white--text"
    >
      <i class="material-icons" style="font-size: 30px;">
        account_circle
      </i>
    </v-btn>

    <v-card class="customMenu animated flipInX">
      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <i class="material-icons green--text">
              account_circle
            </i>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ $store.state.user.fullname }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ $store.state.user.email }}</v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
      </v-list>

      <v-divider></v-divider>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <i class="material-icons light-blue--text">
            info
          </i>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Quotas</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-card-text class="py-0">
        Projects: {{ $store.state.user.projects_count }} / {{ $store.state.user.projects_limit || '&#8734;' }}
      </v-card-text>
      <v-flex d-flex xs12 sm12 md12 class="mr_b-10">
        <v-card-text class="py-0">
          <v-progress-linear
            height="5"
            :value="percentageProjectsCount"
          ></v-progress-linear>
        </v-card-text>
      </v-flex>
      <v-card-text class="py-0">
        Keywords: {{ $store.state.user.keywords_count }} / {{ $store.state.user.keywords_limit || '&#8734;' }}
      </v-card-text>
      <v-flex d-flex xs12 sm12 md12 class="mr_b-10">
        <v-card-text class="py-0">
          <v-progress-linear
            color="info"
            height="5"
            :value="percentageKeywordsCount"
          ></v-progress-linear>
        </v-card-text>
      </v-flex>
      <v-divider v-if="$store.state.user.role !== 'dtnt_user'"></v-divider>
      <v-list-tile v-if="$store.state.user.role !== 'dtnt_user'" avatar>
        <v-list-tile-avatar>
          <i class="material-icons light-blue--text">
            account_balance_wallet
          </i>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Balance: {{ Number($store.state.user.credits.toFixed(2)) }} {{$store.state.metadata.currencySign[$store.state.metadata.currencies[$store.state.user.currency]]}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="$store.state.user.role !== 'dtnt_user'"></v-divider>

      <v-list-tile avatar @click="applyCouponDialog = true">
        <v-list-tile-avatar>
          <i class="material-icons orange--text">add_circle</i>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="orange--text" >Apply Promo Code</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <router-link v-if="$store.state.user.role !== 'dtnt_user'" :to="{ name: 'SubscriptionHistory'}" style="color:#000; text-decoration: none;">
        <v-list-tile avatar @click="userMenu = false">
          <v-list-tile-avatar>
            <i class="material-icons light-blue--text">history</i>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Payment history</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
      <router-link :to="{ name: 'UserSettings'}" style="color:#000; text-decoration: none;">
        <v-list-tile avatar @click="userMenu = false">
          <v-list-tile-avatar>
            <i class="material-icons light-blue--text">settings</i>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Account settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
      <v-list-tile avatar @click="wizardDialog = true">
          <v-list-tile-avatar>
            <i class="material-icons light-blue--text">settings</i>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Configure package</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="logout()" class="orange--text">
          <v-icon>exit_to_app</v-icon>
          Logout
        </v-btn>
      </v-card-actions>
    </v-card>
    <WizardModal v-if="wizardDialog" :wizardDialog="wizardDialog"></WizardModal>
    <ApplyCouponModal v-if="applyCouponDialog" :applyCouponDialog="applyCouponDialog"></ApplyCouponModal>
  </v-menu>
</template>

<script>
export default {
  name: 'UserMenu',
  data () {
    return {
      userMenu: false,
      firstDayOfWeek: 'Sunday',
      applyCouponDialog: false,
      wizardDialog: false
    }
  },
  computed: {
    percentageProjectsCount () {
      return this.$store.state.user.projects_count * 100 / this.$store.state.user.projects_limit
    },
    percentageKeywordsCount () {
      return this.$store.state.user.keywords_count * 100 / this.$store.state.user.keywords_limit
    },
    percentageLinksCount () {
      return this.$store.state.user.links_count * 100 / this.$store.state.user.links_limit
    },
    percentageReportsCount () {
      return this.$store.state.user.made_reports * 100 / this.$store.state.user.reports_limit
    }
  },
  mounted () {
    this.$eventEmitter
      .$on('wizardDialog', (value) => {
        this.wizardDialog = value
      })
      .$on('applyCouponDialog', (value) => {
        this.applyCouponDialog = value
      })
  },
  beforeDestroy () {
    this.$eventEmitter.$off('wizardDialog')
    this.$eventEmitter.$off('applyCouponDialog')
  },
  methods: {
    go (dest) {
      this.$router.push({name: dest})
    },
    logout () {
      this.$store.dispatch('LOGOUT')
      this.$router.push({name: 'SearchTool'})
    }
  }
}
</script>

<style>
.user-menu-box {
  position: fixed;
  top: 56px !important;
  margin-right: 15px;
}
.user-menu-box .v-list__tile--avatar {
  height: 43px;
}
.icon-rotate-180 {
        -webkit-transform: rotate(-180deg);
        -moz-transform: rotate(-180deg);
        -ms-transform: rotate(-180deg);
        -o-transform: rotate(-180deg);
        transform: rotate(-180deg);
    }
</style>



// WEBPACK FOOTER //
// src/components/user-menu/UserMenu.vue